<span class="action__slot">
  <button
    type="button"
    class="ut-btn ut-btn--secondary ut-btn--sm report"
    [class.is-hidden]="reported"
    [attr.aria-busy]="state.busy()"
    (click)="report()">
    @if (state.loading()) {
      <svg class="report__spinner" viewBox="0 0 20 20" aria-hidden="true">
        <circle class="report__track" cx="10" cy="10" r="8"/>
        <circle class="report__arc" cx="10" cy="10" r="8"/>
      </svg>
    } @else {
      <span class="material-icons action__icon" aria-hidden="true">outlined_flag</span>
    }
    Report
  </button>
  <span class="report__badge" [class.is-hidden]="!reported" [class.anim-on]="state.animation() === 'on'">
    <svg class="report__check" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6L9 17l-5-5"/></svg>
    Reported
  </span>
</span>
@if (state.animation() === 'on') {
  <span class="report__helper">A moderator will review it</span>
}
<span class="sr-only" aria-live="polite">{{ state.announcement() }}</span>
